export const measureHeight = (el: HTMLElement) => {
	const cachedStyles = el.getAttribute('style');
	el.setAttribute('style', '');
	const offsetHeight = el.getBoundingClientRect().height;
	const { marginTop, marginBottom, paddingTop, paddingBottom, height } =
		window.getComputedStyle(el);

	if (cachedStyles) {
		el.setAttribute('style', cachedStyles);
	}

	return {
		height,
		marginTop,
		marginBottom,
		paddingTop,
		paddingBottom,
		offsetHeight,
	};
};
